import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Sat Sep 29 2018
 * @author SKu
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { BindDTOConverter, BindIdsDTOConverter, DataPairingProductRowDTOConverter, jsonConversions } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var DataPairingLayer =
/*#__PURE__*/
function () {
  function DataPairingLayer() {
    _classCallCheck(this, DataPairingLayer);
  }

  _createClass(DataPairingLayer, [{
    key: "getOverview",

    /**
     * Fletches products for given categoryId
     * @param data - consist of CategoryId, productName(for filtering)
     * and flag paired(should be false for unpaired page, true for recommended and paired pages)
     */
    value: function getOverview(data) {
      var _this = this;

      var getOverviewPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_PAIRING).concat(CONSTANTS.API.ENDPOINTS.OVERVIEW)).post(data, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.overviewConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return getOverviewPromise;
    } // PIMP: convertors do not work in other places
    // PIMP: Metods for fletching data should be placed in other places

    /**
     * Fletches count of recommended products for each  child category
     */

  }, {
    key: "getStats",
    value: function getStats() {
      var getStatsPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_PAIRING).concat(CONSTANTS.API.ENDPOINTS.STATS)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(item);
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return getStatsPromise;
    }
    /**
     * Pair internal to competitors products
     *
     * @param bindDTOs
     *
     */

  }, {
    key: "pair",
    value: function pair(bindDTOs) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_PAIRING).concat(CONSTANTS.API.ENDPOINTS.PAIR)).post({
                  bindDTOs: bindDTOs.map(function (b) {
                    return _this2.bindDTOConverter.toDocument(b, jsonConversions);
                  })
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
    /**
     * Unpair internal and competitors products
     *
     * @param bindIds
     *
     */

  }, {
    key: "unpairPaired",
    value: function unpairPaired(bindIds) {
      var _this3 = this;

      var unpairPairedPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_PAIRING).concat(CONSTANTS.API.ENDPOINTS.UNPAIR_PAIRED)).post({
        bindIds: bindIds.map(function (b) {
          return _this3.bindIdsDTOConverter.toDocument(b, jsonConversions);
        })
      }, {
        responseType: 'json'
      }).then(function () {
        return Promise.resolve();
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return unpairPairedPromise;
    }
  }, {
    key: "updatePairParameters",
    value: function updatePairParameters(internalProductId, competitorProductId, ratio, charger) {
      var _this4 = this;

      var pairPromise = api("".concat(CONSTANTS.APP.API_HOST).concat(CONSTANTS.API.ENDPOINTS.DATA_PAIRING).concat(CONSTANTS.API.ENDPOINTS.UPDATE_PAIR_PARAMETERS)).put({
        internalProductId: internalProductId,
        competitorProductId: competitorProductId,
        ratio: ratio.toString(),
        charger: charger.toString()
      }, {
        responseType: 'json'
      }).then(function (response) {
        return _this4.overviewConverter.toObject(response.data.result, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
      return pairPromise;
    }
  }]);

  return DataPairingLayer;
}();

__decorate([Inject, __metadata("design:type", DataPairingProductRowDTOConverter)], DataPairingLayer.prototype, "overviewConverter", void 0);

__decorate([Inject, __metadata("design:type", BindDTOConverter)], DataPairingLayer.prototype, "bindDTOConverter", void 0);

__decorate([Inject, __metadata("design:type", BindIdsDTOConverter)], DataPairingLayer.prototype, "bindIdsDTOConverter", void 0);